import about       from '@/pages/about/intro/Intro.vue'
import greeting from "@/pages/about/greeting/Greeting.vue"
import history from "@/pages/about/history/History.vue"
import organization from "@/pages/about/organization/Organization.vue"
import aboutmain from "@/pages/about/about-main/AboutMain.vue"

export default [
    {
        path: '/aboutmain',
        name: 'aboutmain',
        component: aboutmain,
    },
    {
        path: '/about',
        name: 'about',
        component: about,
    },
    {
        path: '/greeting',
        name: 'greeting',
        component: greeting,
    },
    {
        path: '/history',
        name: 'history',
        component: history,
    },
    {
        path: '/organization',
        name: 'organization',
        component: organization,
    }
]
